// @flow
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import IdentityRequirements from './IdentityRequirements';
import { storePassportInfo } from '../../../modules/Customer';
import config from '../../../config';

const mapDispatchToProps = {
  storePassportInfo,
};

const withFlaggedProps = () => ({
  displayIdentityRequirementLink: config.displayIdentityRequirementLink,
});

export default compose(connect(null, mapDispatchToProps), withProps(withFlaggedProps))(IdentityRequirements);
